import { SvgIconProps } from '@mui/material'
import React from 'react'

const Transaction: React.FC<SvgIconProps> = (props) => {
  return (
    <svg
      width={96}
      height={96}
      viewBox='0 0 96 96'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <circle cx={48} cy={48} r={48} fill='#EEF7FF' />
      <path
        d='M68.0001 48.7531V33.4025C68.0001 32.6928 67.4249 32.1176 66.7152 32.1176H45.3318C44.6221 32.1176 44.0469 32.6928 44.0469 33.4025V36.3844H60.399C61.6324 36.3844 62.6322 37.3842 62.6322 38.6176V50.038H66.7152C67.4249 50.038 68.0001 49.4628 68.0001 48.7531Z'
        fill='#219BF3'
      />
      <path
        d='M59.9767 55.4937V40.5066C59.9767 39.6966 59.32 39.0399 58.51 39.0399H37.4901C36.6801 39.0399 36.0234 39.6966 36.0234 40.5066V43.3067H52.3755C53.6089 43.3067 54.6088 44.3065 54.6088 45.5399V56.9604H58.51C59.32 56.9603 59.9767 56.3037 59.9767 55.4937Z'
        fill='#219BF3'
      />
      <path
        d='M50.4736 45.9621H29.4797C28.6624 45.9621 28 46.6246 28 47.4418V62.4029C28 63.2201 28.6624 63.8826 29.4797 63.8826H50.4736C51.2908 63.8826 51.9533 63.2201 51.9533 62.4029V58.3531C51.9522 58.3314 51.95 58.31 51.95 58.2881C51.95 58.2661 51.9522 58.2447 51.9533 58.223V47.4418C51.9533 46.6246 51.2908 45.9621 50.4736 45.9621Z'
        fill='#219BF3'
      />
    </svg>
  )
}

export default Transaction
